import { render, staticRenderFns } from "./ProfilePasswordDialog.vue?vue&type=template&id=22cf46b8&scoped=true&"
import script from "./ProfilePasswordDialog.vue?vue&type=script&lang=js&"
export * from "./ProfilePasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf46b8",
  null
  
)

export default component.exports